/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { CardActionArea, Button, Box, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { REVIEWS_ROUTE } from "../utils/consts";
import { processReviewRequest } from "../http/reviewRequestsAPI";
import {getImageUrl} from "../helpers/getImageUrl";

const ENABLE_IMAGE_HOVER_PREVIEW = false;
const IMAGE_HOVER_WIDTH_FACTOR = 1.12;

const reviewLinkTypeLabels = {
  review1: "Ссылка на отзыв №1",
  review2: "Ссылка на отзыв №2",
  review3: "Ссылка на отзыв №3",
  review4: "Ссылка на отзыв №4",
  review5: "Ссылка на отзыв №5"
};

const ReviewRequestItem = ({ reviewRequest, onUpdate }) => {
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);
  const [isRefuseMode, setIsRefuseMode] = useState(false);
  const [decisionComment, setDecisionComment] = useState("");
  const [localDecision, setLocalDecision] = useState(reviewRequest?.decision ?? null);

  useEffect(() => {
    setLocalDecision(reviewRequest?.decision ?? null);
  }, [reviewRequest?.id, reviewRequest?.decision]);

  const effectiveDecision = localDecision;

  const handleDecision = async (selected, event, comment = "") => {
    event.stopPropagation();
    setIsProcessing(true);
    try {
      await processReviewRequest(reviewRequest.id, selected, comment);
      setLocalDecision(selected === "give");
      setIsRefuseMode(false);
      setDecisionComment("");
      if (onUpdate) {
        onUpdate();
      }
    } catch (error) {
      console.error("Ошибка при обработке заявки:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <Card sx={{ width: 270, m: 1, overflow: "visible" }} elevation={12}>
      <CardActionArea
        onClick={() =>
          navigate(REVIEWS_ROUTE + "/" + reviewRequest.id)
        }
        sx={{ overflow: "visible" }}
      >
        <CardContent>
          <Box
            sx={{
              width: "100%",
              aspectRatio: "9 / 16",
              borderRadius: 1,
              position: "relative",
              overflow: "visible",
              "&:hover .review-request-original-preview": ENABLE_IMAGE_HOVER_PREVIEW ? {
                opacity: 1,
                visibility: "visible",
                transform: "translate(-50%, 0)",
              } : {},
            }}
          >
            <Box
              component="img"
              className="review-request-image"
              src={getImageUrl(reviewRequest.image)}
              alt=""
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: 1,
                position: "relative",
              }}
            />
            {ENABLE_IMAGE_HOVER_PREVIEW && (
              <Box
                component="img"
                className="review-request-original-preview"
                src={getImageUrl(reviewRequest.image)}
                alt=""
                sx={{
                  position: "absolute",
                  left: "50%",
                  top: 0,
                  width: `calc(100% * ${IMAGE_HOVER_WIDTH_FACTOR})`,
                  height: "auto",
                  transform: "translate(-50%, 6px)",
                  transformOrigin: "center top",
                  objectFit: "contain",
                  borderRadius: 1,
                  boxShadow: 10,
                  zIndex: 30,
                  opacity: 0,
                  visibility: "hidden",
                  transition: "opacity 0.18s ease, transform 0.18s ease",
                  pointerEvents: "none",
                  backgroundColor: "#fff",
                }}
              />
            )}
          </Box>

          <Typography variant="body2" component={"div"} sx={{ mt: 1, fontWeight: 'bold' }}>
            {effectiveDecision === null
              ? `Ожидает решения`
              : effectiveDecision === true
              ? `Баллы начислены`
              : `Отказано в начислении`}
          </Typography>

          <Typography variant="body2" component={"div"}>
            Пациент: {reviewRequest.user?.name || "—"} {reviewRequest.user?.phone ? `(${reviewRequest.user.phone})` : ""}
          </Typography>

          <Typography variant="body2" component={"div"}>
            Дата запроса: {new Date(reviewRequest.createdAt).toLocaleDateString()} {new Date(reviewRequest.createdAt).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})}
          </Typography>

          <Typography variant="body2" component={"div"}>
            Тип отзыва: {reviewRequest.reviewTargetType === 'doctor' ? 'На врача' : 'На филиал'}
          </Typography>

          <Typography variant="body2" component={"div"}>
            Филиал: {reviewRequest.branch?.name || "—"}
          </Typography>

          <Typography variant="body2" component={"div"}>
            Площадка: {reviewLinkTypeLabels[reviewRequest.reviewLinkType] || reviewRequest.reviewLinkType || "—"}
          </Typography>

          {reviewRequest.adminComment && (
            <Typography variant="body2" component={"div"}>
              Комментарий: {reviewRequest.adminComment}
            </Typography>
          )}

          {reviewRequest.admin && (
            <Typography variant="body2" component={"div"}>
              Менеджер: {reviewRequest.admin.internalName || reviewRequest.admin.name}
            </Typography>
          )}
        </CardContent>
      </CardActionArea>

      {effectiveDecision === null && (
        <Box sx={{ p: 1 }}>
          {!isRefuseMode ? (
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="success"
                size="small"
                onClick={(e) => handleDecision('give', e)}
                disabled={isProcessing}
              >
                Принять
              </Button>
              <Button
                variant="contained"
                color="error"
                size="small"
                onClick={() => setIsRefuseMode(true)}
                disabled={isProcessing}
              >
                Отказать
              </Button>
            </Box>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <TextField
                size="small"
                placeholder="Комментарий к отказу"
                value={decisionComment}
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => setDecisionComment(e.target.value)}
                multiline
                minRows={2}
              />
              <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                <Button
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsRefuseMode(false);
                    setDecisionComment("");
                  }}
                  disabled={isProcessing}
                >
                  Отменить
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  size="small"
                  onClick={(e) => handleDecision('refuse', e, decisionComment)}
                  disabled={isProcessing}
                >
                  Отказать
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      )}
    </Card>
  );
};

export default ReviewRequestItem;
